import type { ApplicationIcon } from "../types/portal";
import type { ReactNode } from "react";

type IconName = ApplicationIcon | "apps" | "arrow" | "chart-line" | "chevron" | "clock" | "external" | "info" | "menu" | "refresh" | "shield" | "spark" | "x";

export function Icon({ name, className = "" }: { name: IconName; className?: string }) {
  const paths: Record<IconName, ReactNode> = {
    "scan-text": <><path d="M7 3H5a2 2 0 0 0-2 2v2M17 3h2a2 2 0 0 1 2 2v2M7 21H5a2 2 0 0 1-2-2v-2M17 21h2a2 2 0 0 0 2-2v-2"/><path d="M8 7h8v10H8zM10 10h4M10 13h4"/></>,
    assistant: <><path d="M5 5.5A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5v8a2.5 2.5 0 0 1-2.5 2.5H11l-4.5 4v-4A2.5 2.5 0 0 1 4 13.5v-8Z"/><path d="m12 6 .75 2.25L15 9l-2.25.75L12 12l-.75-2.25L9 9l2.25-.75L12 6Z"/></>,
    drawing: <><path d="M4 3h12l4 4v14H4z"/><path d="M16 3v5h5M8 13h8M8 17h5M8 9h4"/></>,
    change: <><path d="M5 4h10l4 4v12H5z"/><path d="M15 4v5h5M9 13h6M12 10v6"/></>,
    apps: <><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></>,
    arrow: <><path d="M5 12h14M14 7l5 5-5 5"/></>,
    "chart-line": <><path d="M3 3v18h18"/><path d="m7 16 4-5 3 3 5-7"/></>,
    chevron: <path d="m7 10 5 5 5-5"/>,
    clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
    external: <><path d="M14 4h6v6M20 4l-9 9"/><path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6"/></>,
    info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/></>,
    menu: <><path d="M4 7h16M4 12h16M4 17h16"/></>,
    refresh: <><path d="M20 6v5h-5"/><path d="M18.5 15a8 8 0 1 1-.6-7.8L20 11"/></>,
    shield: <><path d="M12 3 4 6v5c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10V6l-8-3Z"/><path d="m9 12 2 2 4-4"/></>,
    spark: <><path d="m12 3 1.4 4.6L18 9l-4.6 1.4L12 15l-1.4-4.6L6 9l4.6-1.4L12 3ZM19 15l.7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15Z"/></>,
    x: <><path d="m6 6 12 12M18 6 6 18"/></>,
  };

  return <svg className={`icon ${className}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
